import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { useHistory, useLocation } from 'react-router-dom';
import { LoaderMi, Bouton, InputMi, Row, Col } from '@design-system-etat/dsfr-react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { FormProvider, useForm } from 'react-hook-form';
import TableauArmeASupprimer from './TableauArmeASupprimer';
import styles from '../index.module.scss';
import { formatData } from './FormatData';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    API_SUPPRESSION_ARME_RECUPERER_URL,
    API_SUPPRESSION_ARME_VALIDER_URL,
    CONTEXT_SUPPRESSION_ARME_RECUPERER,
    CONTEXT_SUPPRESSION_ARME_VALIDER,
} from '../../../../../constants/apiUrls.constants';
import RoutesRatelier from '../../../ratelier/routes';
import { getMessageErreurChampManquant } from '../../../../../utils/utils';
import { getPath } from '../../../../../utils/router';

const FormulaireSupprimerArme = ({
    dataProfil,
    postApi,
    reinitialiseApi,
    isLoadingListeArmes,
    dataListeArmes,
    isLoading,
    message,
}) => {
    const [listeArmesASupprimer, setListeArmesASupprimer] = useState([]);
    const history = useHistory();
    const location = useLocation();
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { handleSubmit, register, formState, watch } = hookForm;
    const { isValid } = formState;

    const reinitialiserStore = () => {
        reinitialiseApi(CONTEXT_SUPPRESSION_ARME_VALIDER);
        reinitialiseApi(CONTEXT_SUPPRESSION_ARME_RECUPERER);
    };

    const retourRatelier = () => {
        reinitialiserStore();
        history.push(getPath(RoutesRatelier));
    };

    useEffect(() => {
        if (message) {
            retourRatelier();
        }
    }, [message]);

    useEffect(() => {
        if (dataListeArmes) {
            const listeArmes = dataListeArmes.map((element) => ({
                numeroEncodage: element.numeroEncodage,
                numeroCarcasse: element.numeroCarcasse,
                type: element.type,
                marque: element.marque,
                modele: element.modele,
                calibreCanon: element.calibreCanon,
                calibreCanonDeux: element.calibreCanonDeux,
                classementFrancais: element.classement,
                uniquid: element.uniquid,
            }));
            setListeArmesASupprimer(listeArmes);
        }
    }, [dataListeArmes]);

    useEffect(() => {
        reinitialiserStore();

        // Requête pour récupérer les informations des armes.
        if (location.state.listeArmes) {
            const data = { listeArmesUuid: location.state.listeArmes };

            postApi(
                usagerClientReducer,
                API_SUPPRESSION_ARME_RECUPERER_URL,
                data,
                CONTEXT_SUPPRESSION_ARME_RECUPERER,
            );
        }

        if (!dataProfil) {
            retourRatelier();
        }
    }, []);

    const onSubmit = async (donnees) => {
        const dataToSend = await formatData(donnees);
        dataToSend.listeArmes = listeArmesASupprimer.map((element) => element.uniquid);

        postApi(
            usagerClientReducer,
            API_SUPPRESSION_ARME_VALIDER_URL,
            dataToSend,
            CONTEXT_SUPPRESSION_ARME_VALIDER,
        );
    };

    const supprimerArme = (index) => {
        const listeArmesASupprimerTmp = [...listeArmesASupprimer];
        listeArmesASupprimerTmp.splice(index, 1);
        setListeArmesASupprimer(listeArmesASupprimerTmp);
    };

    const getBoutonAction = (index) => {
        return (
            <Bouton
                className="fr-fi-delete-line"
                niveau="primaire"
                aria-hidden="true"
                onClick={() => supprimerArme(index)}
            />
        );
    };

    const hasFormValid = () => {
        return watch('motif') && isValid;
    };

    return (
        dataProfil && (
            <div style={{ position: 'relative' }}>
                {isLoadingListeArmes || !dataListeArmes ? (
                    <LoaderMi taille="lg" />
                ) : (
                    <div className={styles.armeASupprimer__sousTitre}>
                        <p>
                            Êtes-vous sûr(e) de vouloir supprimer la ou les arme(s) sélectionnée(s)
                            ?
                        </p>
                    </div>
                )}
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {!isLoadingListeArmes && dataListeArmes && (
                            <TableauArmeASupprimer
                                donnees={listeArmesASupprimer.map((element, index) => {
                                    const ligne = { ...element };
                                    delete ligne.uniquid;
                                    ligne.action =
                                        listeArmesASupprimer.length > 1
                                            ? getBoutonAction(index)
                                            : null;

                                    return ligne;
                                })}
                            />
                        )}
                        <div className={styles.armeASupprimer__blocFormulaire}>
                            <InputMi
                                name="motif"
                                label="Veuillez indiquer les raisons de cette demande de suppression :"
                                type="textarea"
                                maxLength="4000"
                                uppercase
                                {...register('motif', {
                                    required: getMessageErreurChampManquant('Modif'),
                                })}
                                error={formState.errors.motif ?? null}
                                placeholder="Veuillez indiquer le motif de cette demande de suppression"
                                required
                            />
                            <div className={styles.armeASupprimer__blocFormulaire_justificatif}>
                                <InputFiles
                                    name="justificatifs"
                                    label="Justificatif(s) :"
                                    multiple
                                    error={formState.errors ? formState.errors.justificatifs : null}
                                    texteAide="Si nécessaire, vous pouvez joindre un ou plusieurs fichiers. La taille maximale autorisée de votre document est 5Mo. Les formats acceptés sont .png, .pdf, .jpeg, .jpg. Attention, si le fichier dépasse les 5 MO au total, veuillez utiliser le formulaire de contact pour envoyer des documents complémentaires à votre préfecture."
                                />
                            </div>
                            <br />
                            <Row goutierre>
                                <Col
                                    lg={6}
                                    className={styles.armeASupprimer__blocFormulaire_bouton_annuler}
                                >
                                    <Bouton
                                        onClick={retourRatelier}
                                        label="Annuler"
                                        niveau="secondaire"
                                    />
                                </Col>
                                <Col
                                    lg={6}
                                    className={
                                        styles.armeASupprimer__blocFormulaire_bouton_confirmer
                                    }
                                >
                                    <Bouton
                                        label="Confirmer la demande de suppression"
                                        niveau="primaire"
                                        type="submit"
                                        disabled={!hasFormValid()}
                                        isLoading={isLoading}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </form>
                </FormProvider>
            </div>
        )
    );
};

FormulaireSupprimerArme.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataProfil: PropTypes.array,
    isLoadingListeArmes: PropTypes.bool,
    dataListeArmes: PropTypes.array,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
};

export default connect(
    (state) => {
        const { data } = state.profil.usager;
        const { message, isLoading } = state.armes.demanderSuppression.reponse;
        const { isLoading: isLoadingListeArmes, data: dataListeArmes } =
            state.armes.demanderSuppression.recuperer;
        return {
            dataProfil: data,
            message,
            isLoading,
            isLoadingListeArmes,
            dataListeArmes,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(FormulaireSupprimerArme);
